import React, { Component, useState } from 'react';
import { Button, Row, Col, Pagination } from 'react-bootstrap'
import "react-datepicker/dist/react-datepicker.css";
import $, { data } from 'jquery'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import EvaluateStudentList from "../../components/EvaluateStudentList";
import EvaluateTeacher from "../../components/EvaluateTeacher";
import EvaluateStudent from "../../components/EvaluateStudent";
import { withRouter } from 'react-router-dom';
import { Helmet } from "react-helmet";

class RoomOverviewEvaluate extends Component {
    constructor(props) {
        super(props);
        this.callbackFromPersonEvaluate = this.callbackFromPersonEvaluate.bind(this);
        console.log(this.props.match.params.roomId)
        this.state = {
            message: [],
            evaluate1: btnEvaluate1('student'),
            evaluate2: btnEvaluate2('self'),
            filter: [],
            data: null,
            roomId: this.props.match.params.roomId,
            pagination: [],
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),
            filterStringQ: null,
            tabKey: 'student',
            dataMode: 'student',
            currentStudentId: '',
            currentStudentName: '',
            currentPage: 1,
            textBtn: AuthService.getUserRole() === 'student' ? 'คำตอบของเรา' : 'คำตอบจากนักเรียน',
            classMainBg: 'bg-white',
            classFillter: 'bg-white',
            classShadow: '',
            report1: 'btn-mm-blue',
            report2: 'btn-mm-outline-blue',
        };
    }

    componentDidMount() {
        this.setState({ dataMode: 'student' });
        this.studentList();
        this.getFilter('student');
        // UserService.getFriendshipReportList(this.state.roomId).then(   
        // (res) => {
        //     const data = res.data.data
        //     let teacher = data.filter(function (d) { return d.user.roles.includes("TEACHER") && d.answerAt !== null });

        // if(teacher[0]){
        //     teacher = teacher[0];
        //   } else{
        //     teacher = data.filter(function (d) { return d.user.roles.includes("TEACHER")})[0];   
        //   }

        //     const teacherId = teacher.user.id
        //     if (teacherId !== AuthService.getCurrentUserId()) {
        //         window.location.href = '/activity'
        //     }
        // });
    }

    callbackFromPersonEvaluate(id, name) {
        // evaluatestudent       
        console.log('callbackFromPersonEvaluate');
        this.setState({
            currentStudentId: id,
            currentStudentName: name,

        }, () => {
            this.updateContent('evaluatestudent');
        });

    }

    studentList() {

        this.setState({ message: <EvaluateStudentList roomId={this.state.roomId} referenceCallback={this.callbackFromPersonEvaluate.bind(this)} /> });
    }

    selfEvaluate() {
        this.setState({ message: <EvaluateTeacher /> });
    }

    evaluateStudentPost() {
        console.log(this.state.currentStudentId);
        this.setState({ message: <EvaluateStudent studentId={this.state.currentStudentId} studentName={this.state.currentStudentName} /> });
    }



    getFilter(tabKey, inputs = null) {
        this.setState({ tabKey: tabKey });
        this.setState({
            classFillter: 'bg-white'
        });
        if (tabKey === 'student') {
            this.setState({ report1: btnEvaluate1(tabKey) });
            this.setState({ report2: btnEvaluate2(tabKey) });

            this.setState({
                filter: ''
            });
        } else if (tabKey === 'self') {

            this.setState({
                classFillter: 'bg-light-blue'
            });
            this.setState({ report1: btnEvaluate1(tabKey) });
            this.setState({ report2: btnEvaluate2(tabKey) });
            this.setState({
                filter:
                    <Row className="p-0 m-auto" ></Row>
            });
        } else if (tabKey === 'evaluatestudent') {

            console.log(this.state.currentStudentName);
            this.setState({ report1: btnEvaluate1('student') });
            this.setState({ report2: btnEvaluate2('student') });
            this.setState({
                filter:
                    <Row className="m-auto" >
                        <Col className="p-0 p-md-2">
                            <Row>
                                <Col style={{ "fontSize": '14px' }}>
                                    <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('student')}>ประเมินนักเรียน ></span> <span style={{ color: '#848DA3' }} className=" font-sarabun-bold">{this.state.currentStudentName}</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            });
        }

    }

    updateContent(menu, inputs = []) {
        var data = '';
        this.getFilter(menu);
        if (menu === 'student') {

            this.studentList();

        } else if (menu === 'self') {

            this.selfEvaluate()

        } else if (menu === 'evaluatestudent') {
            data = this.evaluateStudentPost();

        }

    }

    render() {
        return (
            <div className={`evaluate-report`}>
                <Helmet>
                    <title>การประเมินอุปนิสัยเชิงบวกของนักเรียน และตัวครู - Mindsetmaker.co</title>
                    <meta property="og:title" content={`การประเมินอุปนิสัยเชิงบวกของนักเรียน และตัวครู - Mindsetmaker.co`} />
                    <meta property="og:description" content={`กิจกรรมประเมินด้วยการค้นหาสิ่งดีๆ ในช่วงเวลาที่ผ่านมา เพื่อค้นพบอุปนิสัยเชิงบวกในตัวเรา เพื่อนๆและคุณครู`} />
                </Helmet>
                <Row className="border-bottom-blue">
                    <div className="pt-3 pb-0 btn-main-group text-center w-100">
                        <Button variant="m-2 py-md-1 btn-repot font-sarabun pt-3" className={this.state.report1} onClick={() => this.updateContent('student')}>ประเมินนักเรียน</Button>
                        <Button variant="m-2 py-md-1 btn-repot font-sarabun pt-3" className={this.state.report2} onClick={() => this.updateContent('self')}>ประเมินตัวเอง</Button>
                    </div>
                </Row>
                <Row>
                    <div className={`py-0 px-0 w-100 ${this.state.classMainBg} `}>
                        <div className={`px-4 pt-3 ${this.state.classFillter} ${this.state.classShadow}`} >
                            <div className="main-detail">
                                {this.state.filter}
                            </div>
                        </div>
                        <div className="text-center data-div px-3 font-sarabun">
                            {this.state.message}
                        </div>
                    </div>
                </Row>
            </div>

        );
    }

}


function btnEvaluate1(selectMenu) {
    if (selectMenu === 'student') {
        return "btn-mm-blue";
    } else {
        return "btn-mm-outline-blue";
    }
}

function btnEvaluate2(selectMenu) {
    if (selectMenu === 'self') {
        return "btn-mm-blue";
    } else {
        return "btn-mm-outline-blue";
    }
}



export default withRouter(RoomOverviewEvaluate);